// extracted by mini-css-extract-plugin
module.exports = {"root":"FqmEJ_GfIAnI2hbjXDu9","header":"Kd0gJUSOOhjRBPn9uWMg"};